module.exports = {
  template: require('./gateways-edit-container.pug')()
  controller: require('./gateways-edit-container.ctrl')
}
